<template>
  <div>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      title="表单授权"
      :visible.sync="dialogVisible"
      appendToBody
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <el-container style="padding: 20px 10px">
        <el-header style="padding: 0; height: 30px">
          <el-button size="small" type="primary" @click="getDefaultByFormKey()" style="margin-left: 10px; float: left">
            <el-tooltip content="将表单权限重置为初始化权限，点击确定按钮后生效。"> </el-tooltip>重置
          </el-button>
          <el-popconfirm title="确定清空吗？" @onConfirm="emptyAll" trigger="hover" style="margin-left: 10px; float: left">
            <el-button size="small" slot="reference"> <el-tooltip content="该功能将直接清空表单的权限设置，请谨慎使用。"> </el-tooltip>清空 </el-button>
          </el-popconfirm>
          <!-- <el-button
            @click="addNewField()"
            style="float:right;margin-right: 10px;"
          >
            <el-tooltip
              content="该功能将获取新增字段，初始化新增字段的默认权限。"
            >
              <i class="btn-tip icon-question" /> </el-tooltip
            >新增字段权限
          </el-button> -->
        </el-header>
        <el-main style="padding: 10px; max-height: calc(100vh - 150px); min-height: 200px; overflow: hidden">
          <el-scrollbar class="scrollbar-fullheight" :wrapStyle="[{ maxHeight: 'calc(100vh - 180px)' }]">
            <table class="table table-bordered form-auth__table" style="border-spacing: 0; width: 100%; max-height: calc(100vh - 180px); overflow: initial">
              <thead>
                <tr>
                  <th width="15%" rowspan="2">字段</th>
                  <th width="20%" v-if="pageParams.type != '2' && pageParams.type != '3'">只读权限</th>
                  <th width="80%" v-if="pageParams.type == '2'">只读权限</th>
                  <th width="20%" v-if="pageParams.type != '2' && pageParams.type != '3'">编辑权限</th>
                  <th width="20%" v-if="pageParams.type != '2' && pageParams.type != '3'">必填权限</th>
                  <th width="40%" v-if="pageParams.type == '3'" rowspan="2">必填权限</th>
                  <th width="20%" v-if="pageParams.type != '2' && pageParams.type != '3'">是否隐藏</th>
                  <th width="40%" v-if="pageParams.type == '3'" rowspan="2">字段可见范围</th>
                </tr>
                <tr>
                  <td style="text-align: right" v-if="pageParams.type != '3'">
                    <el-button @click="clickAll('read', 'everyone')">所有人</el-button>
                    <el-button @click="clickAll('read', 'none')">无权限</el-button>
                  </td>
                  <td v-if="pageParams.type != '2' && pageParams.type != '3'">
                    <el-button @click="clickAll('write', 'everyone')">所有人</el-button>
                    <el-button @click="clickAll('write', 'none')">无权限</el-button>
                  </td>
                  <!-- <td v-if="pageParams.type != '2'">
                    <el-button @click="clickAll('required', 'everyone')"
                      >所有人</el-button
                    >
                    <el-button @click="clickAll('required', 'none')"
                      >无权限</el-button
                    >
                  </td>
                  <td style="text-align: center" v-if="pageParams.type != '2'">
                    <el-button @click="hideOrShowAll()">{{
                      checkIsAllhide() ? "隐藏" : "显示"
                    }}</el-button>
                  </td> -->
                </tr>
              </thead>
              <tbody v-for="table in subTableList" :key="table.tableName" class="filed_body">
                <tr>
                  <th colspan="5">
                    <span style="float: left">
                      <span v-if="table.main">主表</span>
                      <span v-if="!table.main">子表</span>
                      ——{{ table.description }}
                    </span>
                    <span v-if="pageParams.type != '2' && !table.main" class="sub-auth__span">
                      <el-checkbox v-model="table.rights.add">添加</el-checkbox>
                      <el-checkbox v-model="table.rights.del">删除</el-checkbox>
                      <el-checkbox v-model="table.rights.hidden">隐藏</el-checkbox>
                      <el-checkbox v-model="table.rights.required">必填</el-checkbox>
                    </span>
                  </th>
                </tr>
                <tr v-for="(field, index) in table.fields" :key="field.fieldName">
                  <td>
                    <span v-if="indexOf(field.description, '固定文本')">固定文本</span>
                    <span v-if="!indexOf(field.description, '固定文本')">{{ field.description }}</span>
                  </td>
                  <td v-if="pageParams.type != '3'">
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'read' + table.description + index"
                        value="everyone"
                        :checked="rightToDesc(field['read']) == '所有人'"
                        @click="selectField(field, 'read', 'everyone')"
                      />所有人
                    </label>
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'read' + table.description + index"
                        value="none"
                        :checked="rightToDesc(field['read']) == '无'"
                        @click="selectField(field, 'read', 'none')"
                      />无
                    </label>
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'read' + table.description + index"
                        value="none"
                        :checked="rightToDesc(field['read']) != '无' && rightToDesc(field['read']) != '所有人'"
                        @click="fieldDialog(field, 'read')"
                      />
                      <el-link type="primary" :underline="false" @click="fieldDialog(field, 'read')">明细</el-link>
                    </label>
                  </td>
                  <td v-if="pageParams.type != '2' && pageParams.type != '3'">
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'write' + table.description + index"
                        value="everyone"
                        :checked="rightToDesc(field['write']) == '所有人'"
                        @click="selectField(field, 'write', 'everyone')"
                      />所有人
                    </label>
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'write' + table.description + index"
                        value="none"
                        :checked="rightToDesc(field['write']) == '无'"
                        @click="selectField(field, 'write', 'none')"
                      />无
                    </label>
                    <label class="radioIn">
                      <input
                        type="radio"
                        :name="'write' + table.description + index"
                        value="none"
                        :checked="rightToDesc(field['write']) != '无' && rightToDesc(field['write']) != '所有人'"
                        @click="fieldDialog(field, 'write')"
                      />
                      <el-link type="primary" :underline="false" @click="fieldDialog(field, 'write')">明细</el-link>
                    </label>
                  </td>
                  <td v-if="pageParams.type != '2'">
                    <label class="radioIn">
                      <input
                        :disabled="field.systemRequired == '1'"
                        type="radio"
                        :name="'required' + table.description + index"
                        value="everyone"
                        :checked="rightToDesc(field['required']) == '所有人'"
                        @click="selectField(field, 'required', 'everyone')"
                      />所有人
                    </label>
                    <label class="radioIn">
                      <input
                        :disabled="field.systemRequired == '1'"
                        type="radio"
                        :name="'required' + table.description + index"
                        value="none"
                        :checked="rightToDesc(field['required']) == '无'"
                        @click="selectField(field, 'required', 'none')"
                      />无
                    </label>
                  </td>
                  <td v-if="pageParams.type != '2'">
                    <label class="radioIn">
                      <!-- <input
                        :disabled="field.systemRequired == '1'"
                        type="radio"
                        :name="'required' + table.description + index"
                        value="none"
                        :checked="
                          rightToDesc(field['required']) != '无' &&
                            rightToDesc(field['required']) != '所有人'
                        "
                        @click="fieldDialog(field, 'required')"
                      /> -->
                      <el-link type="primary" :underline="false" :disabled="field.systemRequired == '1'" @click="fieldDialog(field, 'required')">明细</el-link>
                    </label>
                    <span class="marginLeft16">
                      {{ checkIshideType(field) }}
                    </span>
                    <el-link type="primary" :underline="false" @click="hideColumn(field)" class="marginLeft16" v-if="field.systemRequired != '1'">{{
                      checkIshide(field) == '是' ? '显示' : '隐藏'
                    }}</el-link>
                    <!-- <span>全部显示</span>
                    <el-radio-group :v-model="checkIshide(field)">
                      <el-radio label="是"></el-radio>
                      <el-radio label="否"></el-radio>
                    </el-radio-group> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </el-scrollbar>
        </el-main>
      </el-container>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button> <el-button type="primary" @click="saveAuth" size="small">确 定</el-button>
      </div>
    </el-drawer>
    <eip-auth-dialog @onConfirm="filedAuthConfirm" ref="flowFormFiledAuth" />
  </div>
</template>

<script>
import flow from '@/api/flow.js'
import req from '@/request.js'
import { mapState, mapActions } from 'vuex'

const eipAuthDialog = () => import('@/components/dialog/EipAuthDialog.vue')

export default {
  props: ['defId', 'topDefKey'],
  components: { eipAuthDialog },
  data() {
    return {
      drawerSize: '70%',
      dialogVisible: false,
      _oldPermission: {},
      subTableList: [],
      permissionList: [],
      pageParams: {},
      curAuthieldObj: {}
    }
  },
  methods: {
    selectField: function (field, rightType, action) {
      let data = [{ checked: true, title: '无', type: 'none' }]
      if (action == 'everyone') {
        data = [{ checked: true, title: '所有人', type: 'everyone' }]
      }
      field[rightType] = data
    },
    showDialog: function (param) {
      this.dialogVisible = true
      let this_ = this
      this.pageParams = param
      req.post(req.getContext().form + '/form/rights/v1/getPermissionCustom', param).then((response) => {
        let data = response.data
        data.permissionList.push({ type: 'none', title: '无' })
        this_._oldPermission = JSON.parse(JSON.stringify(data))
        this_.handleData(data)
        let permissionObj = {}
        for (var i = 0, p; (p = data.permissionList[i++]); ) {
          permissionObj[p.type] = p.title
        }
        this_.permissionList = permissionObj
      })
    },
    handleClose: function () {
      this.dialogVisible = false
    },
    addNewField: function () {
      let this_ = this
      req.post(req.getContext().form + '/form/rights/v1/getDefaultByFormKey?type=1&formKey=' + this.pageParams.formKey, this.pageParams).then((response) => {
        let data = response.data
        if (this_._oldPermission) {
          // 不存在的字段，添加进来
          this.deepMerge(data, this_._oldPermission)
        }
        this_.handleData(data)
      })
    },
    deepMerge: function (obj1, obj2) {
      var key
      for (key in obj2) {
        // 如果target(也就是obj1[key])存在，且是对象的话再去调用deepMerge，否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
        if (!obj2.hasOwnProperty(key)) continue
        obj1[key] = obj1[key] && obj1[key].toString() === '[object Object]' ? this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key])
      }
      return obj1
    },
    emptyAll: function () {
      let this_ = this
      req.get(req.getContext().form + '/form/rights/v1/emptyAll?flowKey=' + this.pageParams.flowKey).then((response) => {
        let data = response.data
        if (data.state) {
          this_.$message.success(data.message)
          this_.showDialog(this.pageParams)
        } else {
          this_.$message.fail(data.message)
        }
      })
    },
    getDefaultByFormKey: function () {
      let this_ = this
      req
        .post(req.getContext().form + '/form/rights/v1/getDefaultByFormKeyCustom?type=1&formKey=' + this.pageParams.formKey, this.pageParams)
        .then((response) => {
          if (response.data.state) {
            this.$message.info('重置成功！')
            let data = response.data.value
            this_.handleData(data)
          } else {
            this.$message.error('重置失败！')
          }
        })
    },
    hideOrShowAll: function () {
      if (this.checkIsAllhide()) {
        this.hiddenAll()
      } else {
        this.editAll()
      }
    },
    hiddenAll: function () {
      this.clickAll('read', 'none')
      this.clickAll('write', 'none')
      this.clickAll('required', 'none')
    },
    editAll: function () {
      this.clickAll('read', 'everyone')
      this.clickAll('write', 'none')
      this.clickAll('required', 'none')
    },
    /**
     * 批量权限选择 rightType：权限类型 只读-"read" 编辑-"write" 必填-"required"
     */
    clickAll: function (rightType, type) {
      for (let index = 0; index < this.subTableList.length; index++) {
        const fields = this.subTableList[index].fields
        for (let j = 0, f; (f = fields[j++]); ) {
          f[rightType] = [{ type: type }]
        }
      }
    },
    checkIsAllhide: function () {
      for (let index = 0; index < this.subTableList.length; index++) {
        const fields = this.subTableList[index].fields
        if (fields && fields.constructor == Array) {
          for (var j = 0; j < fields.length; j++) {
            var file = fields[j]
            if (this.checkIshide(file) == '否') {
              return true
            }
          }
        }
      }
      return false
    },
    checkIshide: function (file) {
      let desc = '是'
      if (file && file.read && file.read.length > 0) {
        if (file.read[0].type != 'none') {
          desc = '否'
          return desc
        }
      }
      if (file && file.required && file.required.length > 0) {
        if (file.required[0].type != 'none') {
          desc = '否'
          return desc
        }
      }
      if (file && file.write && file.write.length > 0) {
        if (file.write[0].type != 'none') {
          desc = '否'
          return desc
        }
      }
      return desc
    },
    checkIshideType: function (file) {
      let desc = '是'
      if (file && file.read && file.read.length > 0) {
        if (file.read[0].type == 'none') {
          desc = '全部隐藏'
        } else if (file.read[0].type == 'everyone') {
          desc = '全部可见'
        }
      }
      if (file && file.required && file.required.length > 0) {
        if (file.required[0].type != 'none' && file.required[0].type != 'everyone') desc = '部分可见'
      }
      return desc
    },
    hideColumn: function (field) {
      if (this.checkIshide(field) == '否') {
        field.read = [{ type: 'none' }]
        field.required = [{ type: 'none' }]
        field.write = [{ type: 'none' }]
        this.checkIshideType(field)
      } else {
        field.read = [{ type: 'everyone' }]
        field.required = [{ type: 'none' }]
        field.write = [{ type: 'everyone' }]
        this.checkIshideType(field)
      }
    },
    fieldDialog: function (field, rightType) {
      this.curAuthieldObj['f'] = field
      this.curAuthieldObj['t'] = rightType
      let tmp = JSON.parse(JSON.stringify(field[rightType]))
      let conf = {
        right: tmp,
        permissionList: this._oldPermission.permissionList
      }
      this.$refs.flowFormFiledAuth.showDialog(conf)
    },
    filedAuthConfirm: function (conf) {
      this.curAuthieldObj['f'][this.curAuthieldObj['t']] = conf
    },
    rightToDesc: function (right) {
      let desc = ''
      if (right) {
        right.forEach((element) => {
          if (desc) {
            desc += ' 和 '
          }
          let str = this.permissionList[element.type]
          if (element.name) {
            str += ':' + element.name
          } else if (element.id) {
            str += ':' + element.id
          }
          desc += str
        })
      }

      return desc
    },
    indexOf: function (data, val) {
      if (data.indexOf(val) != -1) {
        return true
      }
      return false
    },
    saveAuth: function () {
      let param = JSON.parse(JSON.stringify(this.pageParams))
      // 提交前拼装回json
      param.permission = {}
      param.permission.table = {}
      var tmp = JSON.parse(JSON.stringify(this.subTableList))
      for (const iterator of tmp) {
        let _fields = {}
        for (const f of iterator.fields) {
          _fields[f.fieldName] = f
        }
        iterator.fields = _fields
        param.permission.table[iterator.tableName] = iterator
      }
      //如果为实例情况，清除读写权限。
      if (param.type == '2') {
        this.handPermissionData(param.permission)
      }
      param.permission = JSON.stringify(param.permission)
      let this_ = this
      req.post(req.getContext().form + '/form/customRight/v1/save', param).then((response) => {
        let data = response.data
        if (data.state) {
          this_.$message.success(data.message)
          this_.dialogVisible = false
        } else {
          this_.$message.fail(data.message)
        }
      })
    },
    handPermissionData: function (json) {
      //param.permission
      let tableJson = json.table
      //遍历表
      for (let key in tableJson) {
        //获取字段
        let fields = tableJson[key].fields
        //遍历字段
        for (let fieleName in fields) {
          //字段信息
          let field = fields[fieleName]
          delete field.write
          delete field.required
        }
      }
      let opinions = json.opinion
      if (!opinions) return

      for (var key in opinions) {
        let opinion = opinions[key]
        delete opinion.write
        delete opinion.required
      }
    },
    handleData: function (data) {
      let tableSn = data.tableSn
      data = data.json
      this.subTableList = []
      tableSn.forEach((obj) => {
        let temp = data.table[obj.name_]
        if (temp) {
          temp.tableName = obj.name_
          let tempArr = []
          for (let fieldName in temp.fields) {
            let fieldTemp = temp.fields[fieldName]
            fieldTemp.fieldName = fieldName
            tempArr.push(fieldTemp)
          }
          tempArr.sort(function (a, b) {
            return a.sn - b.sn
          })
          temp.fields = tempArr
          this.subTableList.push(temp)
        }
      })
    }
  }
}
</script>

<style scoped>
.radioIn {
  margin: 0px 5px 0px 5px;
}
div >>> .el-dialog__body {
  padding: 10px;
}

i.btn-tip {
  margin-right: 5px;
}

.form-auth__table th,
.form-auth__table td {
  border-top: 1px solid #e7eaec;
  border-left: 1px solid #e7eaec;
  line-height: 1.4em;
  padding: 8px;
  vertical-align: middle;
}

.form-auth__table > thead > tr > th,
.form-auth__table > tbody > tr > th {
  background: #fafafa;
}

.table {
  border-bottom: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
}

.filed_body >>> .el-button {
  /* float: right; */
  padding: 4px 6px;
}

.sub-auth__span {
  float: left;
  margin-left: 20px;
}

.sub-auth__span >>> .el-checkbox__label {
  font-size: 12px;
}
</style>
